module.exports = __webpack_public_path__ + "img/hirelamp_logo_footer.0eb96373.svg";